<template>
  <div class="yoyo-container mx-auto min-h-screen pb-[env(safe-area-inset-bottom)]">
    <!-- 导航栏 -->
    <navBar :title="$t('yoyoCoins.title')"></navBar>

    <!-- Yoyo币余额卡片 -->
    <div class="bg-white mx-4 mt-4 rounded-xl p-4 pb-2 text-center">
      <h3 class="text-lg font-medium text-gray-800 mb-2">{{ $t("yoyoCoins.currentBalance") }}</h3>
      <!-- 余额显示 -->
      <div class="flex items-center justify-center mb-2">
        <img :src="yoyoSrc" class="w-8 h-8 mr-1" alt="" />
        <span class="text-4xl font-bold text-[#ff7a00]">{{ extra.point || 0 }}</span>
      </div>
      <!-- 过期提醒 -->
      <div class="text-sm text-gray-500 mb-4" v-if="userInfo.level.level != 3 && userInfo.level.level != 4 && userInfo.level.level != 5">
        ({{ extra.expirePoint || 0 }}{{ $t("yoyoCoins.expireDate") }}{{ extra.expireTime }}{{ $t("yoyoCoins.expireText") }})
      </div>
      <!-- 统计信息 -->
      <div class="text-left text-sm">
        <div class="flex justify-between items-center py-1">
          <span class="text-gray-600">{{ $t("yoyoCoins.accumulated") }}：</span>
          <span class="font-medium">{{ extra.totalPoint || 0 }}</span>
        </div>
        <div class="flex justify-between items-center py-1">
          <span class="text-gray-600">{{ $t("yoyoCoins.used") }}：</span>
          <span class="font-medium">
            {{ extra.usePoint || 0 }}
            <span class="text-sm text-gray-400">({{ $t("yoyoCoins.discountRM") }}RM{{ extra.usePointPrice }} )</span>
          </span>
        </div>
      </div>
    </div>

    <!-- 标签页 -->
    <div class="mx-4 mt-4 bg-white rounded-xl overflow-hidden">
      <van-tabs v-model="activeTab" class="yoyo-tabs yoyo-container" sticky offset-top="3rem" @change="onTabChange">
        <van-tab :title="$t('yoyoCoins.received')" name="received">
          <!-- 已收到记录 -->
          <van-pull-refresh v-model="receivedRefreshing" @refresh="onRefreshReceived" v-if="receivedRecords.length > 0">
            <van-list
              v-model="receivedLoading"
              :finished="receivedFinished"
              :finished-text="$t('query.noMoreData')"
              :loading-text="$t('query.loading')"
              @load="onLoadReceived">
              <div class="px-4">
                <div v-for="(record, index) in receivedRecords" :key="index" class="py-4 border-b border-gray-100 last:border-b-0">
                  <div class="flex justify-between items-start">
                    <div class="flex-1">
                      <div class="font-medium text-gray-800 mb-1">{{ isZh ? record.title : record.titleEn }}</div>
                      <div class="text-sm text-gray-500 mb-1">{{ isZh ? record.description : record.descriptionEn }}</div>
                      <div class="text-sm text-gray-400">{{ formatTime(record.createTime) }}</div>
                    </div>
                    <div class="text-right">
                      <div class="text-lg font-bold text-green-500">+{{ record.point }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
          <van-empty v-if="receivedRecords.length === 0" :description="$t('common.noData')" />
        </van-tab>

        <van-tab :title="$t('yoyoCoins.usageRecord')" name="usage">
          <!-- 使用记录 -->
          <van-pull-refresh v-model="usageRefreshing" @refresh="onRefreshUsage" v-if="usageRecords.length > 0">
            <van-list
              v-model="usageLoading"
              :finished="usageFinished"
              :finished-text="$t('query.noMoreData')"
              :loading-text="$t('query.loading')"
              @load="onLoadUsage">
              <div class="px-4">
                <div v-for="(record, index) in usageRecords" :key="index" class="py-4 border-b border-gray-100 last:border-b-0">
                  <div class="flex justify-between items-start">
                    <div class="flex-1">
                      <div class="font-medium text-gray-800 mb-1">{{ isZh ? record.title : record.titleEn }}</div>
                      <div class="text-sm text-gray-500 mb-1">{{ isZh ? record.description : record.descriptionEn }}</div>
                      <div class="text-sm text-gray-400">{{ formatTime(record.createTime) }}</div>
                    </div>
                    <div class="text-right">
                      <div class="text-lg font-bold text-red-500">{{ record.point }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
          <van-empty v-if="usageRecords.length === 0" :description="$t('common.noData')" />
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { Tabs, Tab, PullRefresh, List, Empty } from "vant"
import { getPointRecord } from "@/apis/mine"
import { mapGetters } from "vuex"
import dayjs from "dayjs"

export default {
  name: "YoyoCoins",
  components: {
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Empty.name]: Empty,
  },
  data() {
    return {
      activeTab: "received",
      yoyoSrc: require("@/assets/images/yoyo.png"),
      // 已收到分页
      receivedRecords: [],
      receivedLoading: false,
      receivedFinished: false,
      receivedRefreshing: false,
      receivedPageNo: 1,
      receivedPageSize: 10,
      // 使用分页
      usageRecords: [],
      usageLoading: false,
      usageFinished: false,
      usageRefreshing: false,
      usagePageNo: 1,
      usagePageSize: 10,
      // 统计信息
      extra: {},
      
    }
  },
  computed: {
    ...mapGetters({
      userInfo: "auth/userInfo",
      isZh: "lang/isZh",
      isLoggedIn: "auth/isLoggedIn",
    }),
  },
  methods: {
    formatTime(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss")
    },
    // 标签页切换
    onTabChange() {
      if (this.activeTab === "received" && this.receivedRecords.length === 0) {
        this.getPointRecord(false)
      } else if (this.activeTab === "usage" && this.usageRecords.length === 0) {
        this.getPointRecord(true)
      }
    },
    // 已收到 - 下拉刷新
    onRefreshReceived() {
      this.receivedPageNo = 1
      this.receivedFinished = false
      this.receivedRecords = []
      this.getPointRecord(false)
    },
    // 已收到 - 上拉加载
    onLoadReceived() {
      this.getPointRecord(false)
    },
    // 使用 - 下拉刷新
    onRefreshUsage() {
      this.usagePageNo = 1
      this.usageFinished = false
      this.usageRecords = []
      this.getPointRecord(true)
    },
    // 使用 - 上拉加载
    onLoadUsage() {
      this.getPointRecord(true)
    },
    // 获取积分记录
    async getPointRecord(isUsage = false) {
      try {
        const params = {
          pageNo: isUsage ? this.usagePageNo : this.receivedPageNo,
          pageSize: isUsage ? this.usagePageSize : this.receivedPageSize,
          addStatus: !isUsage, // received时true，usage时false
        }
        const res = await getPointRecord(params)
        const list = res.data.list || []

        // 更新统计信息
        this.extra = res.data.extra || {}

        if (isUsage) {
          // 使用记录
          if (this.usagePageNo === 1) {
            this.usageRecords = list
            this.usageRefreshing = false
          } else {
            this.usageRecords = [...this.usageRecords, ...list]
          }
          this.usageLoading = false

          // 判断是否加载完
          if (res.data.total <= this.usageRecords.length) {
            this.usageFinished = true
          } else {
            this.usagePageNo++
          }
        } else {
          // 已收到记录
          if (this.receivedPageNo === 1) {
            this.receivedRecords = list
            this.receivedRefreshing = false
          } else {
            this.receivedRecords = [...this.receivedRecords, ...list]
          }
          this.receivedLoading = false

          // 判断是否加载完
          if (res.data.total <= this.receivedRecords.length) {
            this.receivedFinished = true
          } else {
            this.receivedPageNo++
          }
        }

        console.log("积分记录:", res)
      } catch (error) {
        console.log("获取积分记录失败:", error)
        if (isUsage) {
          this.usageLoading = false
          this.usageRefreshing = false
        } else {
          this.receivedLoading = false
          this.receivedRefreshing = false
        }
      }
    },
    goBack() {
      this.$router.go(-1)
    },
  },
  created() {
    this.getPointRecord(false)
  },
}
</script>

<style scoped>
/deep/ .van-sticky {
  width: 100%;
}

@media (width >= 40rem) {
  :deep(.van-sticky) {
    max-width: 40rem;
    margin-inline: auto;
    padding: 0 1rem;
  }
}

@media (width >= 48rem) {
  :deep(.van-sticky) {
    max-width: 48rem;
    margin-inline: auto;
    padding: 0 1rem;
  }
}

@media (width >= 64rem) {
  :deep(.van-sticky) {
    max-width: 64rem;
    margin-inline: auto;
    padding: 0 1rem;
  }
}
@media (width >= 80rem) {
  :deep(.van-sticky) {
    max-width: 64rem;
    margin-inline: auto;
    padding: 0 1rem;
  }
}
@media (width >= 96rem) {
  :deep(.van-sticky) {
    max-width: 72rem;
    margin-inline: auto;
    padding: 0 1rem;
  }
}
</style>
